import React, { useEffect, useState } from "react";
import apiCompany from "../../../apis/company/apiCompany";
import AppAlert from "../../common/AppAlert";
import AppLoading from "../../common/AppLoading";
import BreadCrumb from "../../common/AppBreadCrumb";
import AppInput from "../../controls/AppInput";
import AppSelect from "../../controls/AppSelect";
import AppTitle from "../../controls/AppTitle";
import { useHistory, useLocation } from "react-router";
import apiService from "../../../apis/service/apiService";

function ServiceEditScreen() {
	const history = useHistory();
	const location = useLocation();

	const [id, setId] = useState(null);
	const [name, setName] = useState("");
	const [price, setPrice] = useState(null);
	const [endTime, setEndTime] = useState(null);
	const [initTime, setInitTime] = useState(null);

	const [company, setCompany] = useState({});
	const [companyList, setCompanyList] = useState([]);

	const [loading, setLoading] = useState(false);
	const [errorsForm, setErrorsForm] = useState({});

	const EditContractor = async () => {
		const service = {
			id: id,
			name: name,
			company_id: company.value,
			start_time: initTime,
			end_time: endTime,
			price: price,
		};

		setLoading(true);
		const response = await apiService.updateService(service);
		setLoading(false);

		if (response.ok) {
			history.goBack();
			setErrorsForm({});
			AppAlert.SimpleAlert(response.message);
		} else {
			setErrorsForm(response);
		}
	};

	const GetCompanies = async (company_id) => {
		const response = await apiCompany.getCompaniesDropdown();

		if (response.ok) {
			const company = response.data.find((x) => x.value == company_id);
			setCompany(company);
			setCompanyList(response.data);
		}
	};

	useEffect(() => {
		const service = location.state;

		setId(service.id);
		setName(service.name);
		setPrice(service.price);
		setEndTime(service.end_time);
		setInitTime(service.start_time);

		GetCompanies(service.company);
	}, []);

	return (
		<div className="row">
			<div className="col-12">
				<AppTitle text="Edición de Servicio" />
				<BreadCrumb items={[{ label: "Servicios" }, { label: "Edición de Servicio", active: true }]} />
			</div>
			<div className="card col-12">
				<div className="row card-body col-12">
					<div className="row card-body col-12">
						<div className="col-6">
							<AppInput
								label="Nombre del Servicio"
								type="text"
								defaultValue={name}
								onChange={({ target }) => setName(target.value)}
								placeholder="Nombre del Servicio"
								errors={errorsForm.name}
							/>
						</div>
						<div className="col-6">
							<AppInput
								label="Precio del Servicio"
								type="text"
								defaultValue={price}
								onChange={({ target }) => setPrice(target.value)}
								placeholder="Precio"
								errors={errorsForm.price}
							/>
						</div>
						<div className="col-3">
							<AppInput
								label="Hora Inicio"
								type="text"
								defaultValue={initTime}
								onChange={({ target }) => setInitTime(target.value)}
								placeholder="Inicio"
								errors={errorsForm.start_time}
							/>
						</div>
						<div className="col-3">
							<AppInput
								label="Hora Fin"
								defaultValue={endTime}
								type="text"
								onChange={({ target }) => setEndTime(target.value)}
								placeholder="Fin"
								errors={errorsForm.end_time}
							/>
						</div>
						<div className="col-6">
							<AppSelect
								label="Compañía"
								value={company}
								items={companyList}
								onChange={(dinner) => setCompany(dinner ? dinner : {})}
								errors={errorsForm.company_id}
							/>
						</div>
					</div>
					<div className="col-12 text-center my-4">
						<button className="btn btn-primary" onClick={EditContractor}>
							Editar Servicio
						</button>
					</div>
				</div>
			</div>
			<AppLoading visible={loading} />
		</div>
	);
}

export default ServiceEditScreen;
